import Vue from 'vue';
import VueMq from 'vue-mq';

Vue.use(VueMq, {
    breakpoints: {
        xs: 414,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: Infinity,
    },
});
